import React from 'react';
import './AdminChoiceModal.css';
import HeroSection from './HeroSection';

interface AdminChoiceModalProps {
  onSelectAdmin: () => void;
  onSelectEvaluationForm: () => void;
}

const AdminChoiceModal: React.FC<AdminChoiceModalProps> = ({ onSelectAdmin, onSelectEvaluationForm }) => {
  return (
    <div className="admin-choice-wrapper">
      <HeroSection />
      <div className="modal-overlay">
        <div className="modal-content">
        <h2>Welcome, Admin!</h2>
        <p>What would you like to do?</p>
        <div className="modal-buttons">
          <button onClick={onSelectAdmin} className="modal-btn admin-btn">
            Admin Page
          </button>
          <button onClick={onSelectEvaluationForm} className="modal-btn form-btn">
            Player Performance Evaluation Form
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default AdminChoiceModal;






